module.exports = __webpack_public_path__ + "static/media/IMG_5531.45f69572.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/IMG_5531.JPG
// module id = 573
// module chunks = 0